import React from 'react';
import { FaShoppingCart, FaHeart, FaStar } from 'react-icons/fa';
import './GearCard.css';

const GearCard = ({ 
  imageUrl, 
  category, 
  productName, 
  details, 
  ratePerDay,
  rating,
  isFeatured = false
}) => {
  return (
    <div className={`gear-card ${isFeatured ? 'featured' : ''}`}>
      {isFeatured && <div className="featured-badge">Featured</div>}
      
      <div className="gear-image-container">
        <div className="image-wrapper">
          <img src={imageUrl} alt={productName} className="gear-image" />
        </div>
        {/* <div className="gear-actions">
          <button className="action-btn wishlist-btn" aria-label="Add to wishlist">
            <FaHeart />
          </button>
          <button className="action-btn cart-btn" aria-label="Add to cart">
            <FaShoppingCart />
          </button>
        </div> */}
      </div>
      
      <div className="gear-info">
        <span className="gear-category">{category}</span>
        <h3 className="gear-name">{productName}</h3>
        <p className="gear-details">{details}</p>
        
        {/* <div className="gear-footer">
          <div className="gear-rating">
            <FaStar className="star-icon" />
            <span>{rating}</span>
          </div>
          <div className="gear-pricing">
            <span className="rate-label">From</span>
            <span className="rate-amount">${ratePerDay}</span>
            <span className="rate-period">/day</span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default GearCard;